module.exports = __webpack_public_path__ + "static/media/microwave.f8a26b4f.svg";